import { Button } from "antd";

export default function BotonSubmit({ tituloBoton, onClick, disabled }) {
  return (
    <Button disabled={disabled} onClick={onClick} className="botonSubmit">
      {tituloBoton}
    </Button>
  );
}
